import React from 'react';

export const VenetianRevealFit = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 95.4 61.8" {...props}>
      <path fill="#fff" d="M4.879.534h85.7v60.7h-85.7z" />
      <path
        d="M90.579 61.834h-85.7c-.3 0-.6-.3-.6-.6V.534c0-.3.3-.6.6-.6h85.7c.3 0 .6.3.6.6v60.7c0 .3-.3.6-.6.6zm-85.2-1.2h84.6v-59.5h-84.6v59.5z"
        fill="#dcd9d5"
      />
      <path fill="#fff" d="M4.879.534h85.7v60.7h-85.7z" />
      <path
        d="M90.579 61.834h-85.7c-.3 0-.6-.3-.6-.6V.534c0-.3.3-.6.6-.6h85.7c.3 0 .6.3.6.6v60.7c0 .3-.3.6-.6.6zm-85.2-1.2h84.6v-59.5h-84.6v59.5z"
        fill="#dcd9d5"
      />
      <g fill="#dcd9d5">
        <path d="M8.879 4.534h77.7v52.7h-77.7z" />
        <path d="M86.579 57.834h-77.7c-.3 0-.6-.3-.6-.6v-52.7c0-.3.3-.6.6-.6h77.7c.3 0 .6.3.6.6v52.7c0 .3-.3.6-.6.6zm-77.2-1.2h76.6v-51.5h-76.6v51.5z" />
      </g>
      <path
        d="M94.879 61.734H.479c-.3 0-.5-.2-.5-.5s.2-.5.5-.5h94.4c.3 0 .5.2.5.5.1.3-.2.5-.5.5z"
        fill="#dcd9d5"
      />
      <g>
        <path d="M10.5 39.3h74.3l2.4 5.2H8.1l2.4-5.2z" fill="#233762" />
        <path
          d="M88 44.9H7.5l2.8-6.2h74.8l2.9 6.2zM8.8 44h77.8l-2-4.2H10.8l-2 4.2z"
          fill="#fff"
        />
        <path d="M10.5 35.4h74.3l2.4 5.2H8.1l2.4-5.2z" fill="#233762" />
        <path
          d="M88 41.1H7.5l2.8-6.2h74.8l2.9 6.2zm-79.2-1h77.8l-2-4.2H10.8l-2 4.2z"
          fill="#fff"
        />
        <path d="M10.5 31.5h74.3l2.4 5.2H8.1l2.4-5.2z" fill="#233762" />
        <path
          d="M88 37.2H7.5l2.8-6.2h74.8l2.9 6.2zm-79.2-.9h77.8l-2-4.2H10.8l-2 4.2z"
          fill="#fff"
        />
        <path d="M10.5 27.7h74.3l2.4 5.2H8.1l2.4-5.2z" fill="#233762" />
        <path
          d="M88 33.4H7.5l2.8-6.2h74.8l2.9 6.2zm-79.2-1h77.8l-2-4.2H10.8l-2 4.2z"
          fill="#fff"
        />
        <path d="M10.5 23.8h74.3l2.4 5.2H8.1l2.4-5.2z" fill="#233762" />
        <path
          d="M88 29.5H7.5l2.8-6.2h74.8l2.9 6.2zm-79.2-1h77.8l-2-4.2H10.8l-2 4.2z"
          fill="#fff"
        />
        <g>
          <path d="M10.5 20h74.3l2.4 5.2H8.1l2.4-5.2z" fill="#233762" />
          <path
            d="M88 25.6H7.5l2.8-6.2h74.8l2.9 6.2zm-79.2-.9h77.8l-2-4.2H10.8l-2 4.2z"
            fill="#fff"
          />
        </g>
        <g>
          <path d="M10.5 16.1h74.3l2.4 5.2H8.1l2.4-5.2z" fill="#233762" />
          <path
            d="M88 21.8H7.5l2.8-6.2h74.8l2.9 6.2zm-79.2-1h77.8l-2-4.2H10.8l-2 4.2z"
            fill="#fff"
          />
        </g>
        <g>
          <path d="M10.5 12.2h74.3l2.4 5.2H8.1l2.4-5.2z" fill="#233762" />
          <path
            d="M88 17.9H7.5l2.8-6.2h74.8l2.9 6.2zM8.8 17h77.8l-2-4.2H10.8l-2 4.2z"
            fill="#fff"
          />
        </g>
        <g>
          <path d="M10.5 8.4h74.3l2.4 5.2H8.1l2.4-5.2z" fill="#233762" />
          <path
            d="M88 14.1H7.5l2.8-6.2h74.8l2.9 6.2zm-79.2-1h77.8l-2-4.2H10.8l-2 4.2z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M8.1 4.2h79.1V9H8.1z" />
          <path
            d="M87.6 9.4H7.8V3.8h79.8v5.6zM8.5 8.6H87v-4H8.5v4z"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};
